import Toast from '@/components/Toast';
export default class ToastUtils {
    static showAbnormalToast(msg) {
        Toast.info(msg);
    }

    static showSuccessToast(msg) {
        Toast.info(msg);
    }

    static showToast(msg) {
        Toast.info(msg);
    }
}
